'use strict';
// write code here
var inputs = document.querySelectorAll('form input');
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var input = _step.value;
        var label = document.createElement('label');
        label.className = 'field-label';
        label.htmlFor = input.id;
        label.textContent = capitalize(input.name);
        input.placeholder = capitalize(input.name);
        input.parentElement.prepend(label);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
function capitalize(text) {
    return text.replace(/([A-Z])/g, ' $1').replace(/^./, function(firstLetter) {
        return firstLetter.toUpperCase();
    });
}

//# sourceMappingURL=js_task_fix_form_DOM.f6edc496.js.map
